import type { MarkerClustererOptions } from '@google/markerclustererplus'

/**
 * Coordinates of the Aalberts main office.
 */
export const mainOfficeCoordinates = {
    lat: 52.089668,
    lng: 5.1069867,
}

/**
 * Single location pin image
 * @type {string}
 */
export const mapPinImage = `${window.location.origin}/images/pin.png`

/**
 * Cluster image URL
 * @type {string}
 */
export const mapClusterImage = `${window.location.origin}/images/cluster.png`

export const clustererDefaults: MarkerClustererOptions = {
    imagePath: mapClusterImage,
    styles: [
        {
            textColor: 'white',
            url: mapClusterImage,
            height: 30,
            width: 58,
            anchorText: [7, 2],
            textSize: 14,
            fontWeight: 'bold',
        },
    ],
}

export const googleMapsStyleSheet: google.maps.MapTypeStyle[] = [
    {
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#f5f5f5',
            },
        ],
    },
    {
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#ffffff',
            },
        ],
    },
    {
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#ff0000',
            },
        ],
    },
    {
        'elementType': 'labels',
        'stylers': [
            {
                'visibility': 'off',
            },
        ],
    },
    {
        'elementType': 'labels.icon',
        'stylers': [
            {
                'visibility': 'off',
            },
        ],
    },
    {
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#616161',
            },
        ],
    },
    {
        'elementType': 'labels.text.stroke',
        'stylers': [
            {
                'color': '#f5f5f5',
            },
        ],
    },
    {
        'featureType': 'administrative',
        'elementType': 'geometry',
        'stylers': [
            {
                'visibility': 'off',
            },
        ],
    },
    {
        'featureType': 'administrative.land_parcel',
        'stylers': [
            {
                'visibility': 'off',
            },
        ],
    },
    {
        'featureType': 'administrative.land_parcel',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#bdbdbd',
            },
        ],
    },
    {
        'featureType': 'administrative.neighborhood',
        'stylers': [
            {
                'visibility': 'off',
            },
        ],
    },
    {
        'featureType': 'poi',
        'stylers': [
            {
                'visibility': 'off',
            },
        ],
    },
    {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#eeeeee',
            },
        ],
    },
    {
        'featureType': 'poi',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#757575',
            },
        ],
    },
    {
        'featureType': 'poi.park',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#e5e5e5',
            },
        ],
    },
    {
        'featureType': 'poi.park',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#9e9e9e',
            },
        ],
    },
    {
        'featureType': 'road',
        'stylers': [
            {
                'visibility': 'off',
            },
        ],
    },
    {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#ffffff',
            },
        ],
    },
    {
        'featureType': 'road',
        'elementType': 'labels.icon',
        'stylers': [
            {
                'visibility': 'off',
            },
        ],
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#757575',
            },
        ],
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#dadada',
            },
        ],
    },
    {
        'featureType': 'road.highway',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#616161',
            },
        ],
    },
    {
        'featureType': 'road.local',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#9e9e9e',
            },
        ],
    },
    {
        'featureType': 'transit',
        'stylers': [
            {
                'visibility': 'off',
            },
        ],
    },
    {
        'featureType': 'transit.line',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#e5e5e5',
            },
        ],
    },
    {
        'featureType': 'transit.station',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#eeeeee',
            },
        ],
    },
    {
        'featureType': 'water',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#f2f2f2',
            },
        ],
    },
    {
        'featureType': 'water',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#f2f2f2',
            },
        ],
    },
]
